<template>
  <v-card class="elevation-0">
    <v-dialog
      v-model="changeValueDialog.show"
      width="300"
      style="z-index: 90099999 !important"
    >
      <v-card>
        <v-btn icon class="close-btn" @click="changeValueDialog.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title>编辑设定值</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="changeValueDialog.value"
            type="text"
            placeholder="请输入设定值"
            style="width: 100%"
          /></v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="submitChangeValue">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row dense class="px-4">
      <v-col cols="12" md="5">
        <div class="flex-y-center pt-4 mb-3">
          <div class="flex-1 flex-y-center">
            <span
              class="mr-2 flex-0"
              style="min-width: 80px; white-space: nowrap"
            >类型名称：</span>
            <input
              v-model="search.data.name"
              class="default-input py-1 subtitle-1"
              placeholder="按类型名称搜索"
              type="text"
              style="width: 160px !important"
              @keyup.enter="getList()"
            >
            <v-btn
              class="ml-3"
              color="primary"
              depressed
              small
              :loading="btnLoading"
              @click="getList"
            >搜索</v-btn>
            <v-btn
              class="ml-2"
              depressed
              small
              :loading="btnLoading"
              @click="resetSearch"
            >重置</v-btn>
          </div>
          <v-btn color="#00bea9" depressed dark small @click="showAdd">
            <v-icon size="20">mdi-plus</v-icon>
            <span class="ml-1">新增类型</span>
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="list"
          :item-class="getRowClass"
          :items-per-page="search.pageSize"
          :single-select="true"
          :value="selectedItem"
          class="pb-5 max-width px-4 type-table"
          hide-default-footer
          disable-sort
          item-key="id"
          no-data-text="暂无查询数据"
          @click:row="onTypeSelected"
        >
          <!--          <template v-slot:item.select="{ item }">-->
          <!--            <v-radio-group v-model="selectedTypeId" class="ma-0 pa-0 radio-center" dense>-->
          <!--              <v-radio :value="item.id" @change="onTypeSelected(item)" />-->
          <!--            </v-radio-group>-->
          <!--          </template>-->
          <template v-slot:item.active="{ item }">
            <a class="mr-2" @click="onEdit(item)">编辑</a>
            <a class="mr-2" @click="onToggle(item)">{{
              item.status === '0' ? '禁用' : '启用'
            }}</a>
            <a class="mr-2" @click="onDelete(item)">删除</a>
          </template>
        </v-data-table>
        <!-- <v-pagination
          v-if="total > search.pageSize"
          v-model="search.pageNo"
          :length="Math.ceil(total / search.pageSize)"
          circle
          class="px-0 pb-4"
          @input="getList"
        /> -->
        <pagination
          v-model="search.pageNo"
          :size="search.pageSize"
          :total="total"
          @input="getList()"
          @changePageSize="
            (e) => {
              search.pageSize = e;
              getList();
            }
          "
        />
      </v-col>
      <v-col v-if="selectedTypeId" cols="12" md="7">
        <v-card class="elevation-0">
          <div class="flex-y-center pt-4 px-2 mb-3">
            <div class="flex-1 flex-y-center">
              <span
                class="mr-2 flex-0"
                style="min-width: 80px; white-space: nowrap"
              >流程名称：</span>
              <input
                v-model="process.search.name"
                class="default-input py-1 subtitle-1"
                placeholder="按流程名称搜索"
                type="text"
                style="width: 160px !important"
                @keyup.enter="getProcessList()"
              >
              <v-btn
                class="ml-3"
                color="primary"
                depressed
                small
                :loading="btnLoading"
                @click="getProcessList"
              >搜索</v-btn>
              <v-btn
                class="ml-2"
                depressed
                small
                :loading="btnLoading"
                @click="resetProcessSearch"
              >重置</v-btn>
            </div>
            <v-btn color="#00bea9" depressed dark small @click="showAddProcess">
              <v-icon size="20">mdi-plus</v-icon>
              <span class="ml-1">新增流程</span>
            </v-btn>
          </div>
          <v-data-table
            :headers="process.headers"
            :items="paginatedItems"
            :item-class="getRowClass1"
            :items-per-page="10"
            class="pb-5 max-width px-4"
            hide-default-footer
            item-key="id"
            disable-sort
            :single-select="true"
            :value="selectedItem1"
            no-data-text="暂无查询数据"
            @click:row="onTypeSelectedR"
          >
            <template v-slot:item.index="{ item }">
              {{ item.sortOrder }}
            </template>
            <template v-slot:item.formName="{ item }">
              <a v-if="!item.formName" @click="onBindForm(item)">关联表单</a>
              <span v-else>{{ item.formName }}</span>
            </template>
            <template v-slot:item.steps="{ item }">
              <a
                v-if="!item.stepFlag && item.formName"
                @click="onSetSteps(item)"
              >{{ item.stepFlag ? '修改' : '设置' }}流程步骤</a>
              <span v-else-if="!item.formName" style="color: darkgrey">设置流程步骤</span>
              <a v-else style="color: #096dd9" @click="onSetSteps(item)">修改流程步骤</a>
            </template>
            <template v-slot:item.active="{ item }">
              <a class="mr-2" @click="onEditProcess(item)">编辑</a>
              <a
                v-if="item.processLaunchCount == 0"
                class="mr-2"
                @click="onBindForm(item)"
              >切换表单</a>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="mr-2"
                    style="color: darkgrey"
                    v-bind="attrs"
                    v-on="on"
                  >
                    切换表单
                  </span>
                </template>
                <span>该流程已经发起过审批，无法切换表单</span>
              </v-tooltip>
              <a class="mr-2" @click="onToggleProcess(item)">{{
                item.publishStatus == '1' ? '禁用' : '启用'
              }}</a>
              <a class="mr-2" @click="onDeleteProcess(item)">删除</a>
            </template>
            <!-- 自定义分页 -->
            <template v-slot:footer>
              <div class="d-flex justify-space-between align-center pa-4">
                <div class="text-caption">
                  显示 {{ startItem }}-{{ endItem }} 条，共 {{ totalItems }} 条
                </div>
                <v-pagination
                  v-model="currentPage"
                  :length="totalPages"
                  :total-visible="7"
                  circle
                />
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog.show" width="500">
      <v-card>
        <v-card-title class="font-weight-bold">{{
          dialog.data.id ? '编辑类型' : '新增类型'
        }}</v-card-title>
        <v-divider />
        <v-card-text class="py-5">
          <div class="px-8">
            <div class="mb-6 flex-align-start">
              <div
                class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
              >
                <span style="color: #f56c6c">*</span> 序号：
              </div>
              <input
                v-model.number="dialog.data.sortOrder"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="序号（数字，用于排序）"
                type="number"
                max="10000"
              >
            </div>
            <div class="mb-6 flex-align-start">
              <div
                class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
              >
                <span style="color: #f56c6c">*</span> 类型名称：
              </div>
              <input
                v-model="dialog.data.name"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="类型名称"
                type="text"
                maxlength="30"
              >
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="max-width flex-y-center flex-justify-end px-4 py-2">
            <v-btn
              width="80"
              class="mr-3"
              depressed
              @click="dialog.show = false"
            >取消</v-btn>
            <v-btn width="80" color="primary" depressed @click="submitSave">保存</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="processDialog.show" width="500">
      <v-card>
        <v-card-title class="font-weight-bold">{{
          processDialog.id ? '编辑流程' : '新增流程'
        }}</v-card-title>
        <v-divider />
        <v-card-text class="py-5">
          <div class="px-8">
            <div class="mb-6 flex-align-start">
              <div
                class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
              >
                <span style="color: #f56c6c">*</span> 序号：
              </div>
              <input
                v-model.number="processDialog.sortOrder"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="序号（数字，用于排序）"
                type="number"
                max="10000"
              >
            </div>
            <div class="mb-6 flex-align-start">
              <div
                class="form-title flex-0 flex-shrink-0 flex-justify-end mt-2"
              >
                <span style="color: #f56c6c">*</span> 流程名称：
              </div>
              <input
                v-model="processDialog.name"
                class="flex-1 default-input py-1 subtitle-1"
                placeholder="流程名称"
                type="text"
                maxlength="30"
              >
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="max-width flex-y-center flex-justify-end px-4 py-2">
            <v-btn
              width="80"
              class="mr-3"
              depressed
              @click="processDialog.show = false"
            >取消</v-btn>
            <v-btn width="80" color="primary" depressed @click="submitProcess">保存</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 表单绑定弹窗 -->
    <v-dialog v-model="formBindDialog.show" max-width="600" persistent>
      <v-card>
        <v-card-title class="text-h6">
          关联表单 - {{ formBindDialog.processName }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <div class="mb-4">
            <div class="mb-3">
              <v-btn color="primary" depressed small @click="createForm">
                <v-icon size="16" class="mr-1">mdi-plus</v-icon>
                创建新表单
              </v-btn>
            </div>
            <div class="text-subtitle-1 mb-2">请选择要关联的表单：</div>
            <template>
              <div style="display: block !important">
                <v-radio-group
                  v-model="formBindDialog.selectedFormId"
                  dense
                  class="mt-2"
                  style="padding: 5px"
                >
                  <v-radio
                    v-for="form in validForms"
                    :key="form.id"
                    :value="form.id"
                    :label="form.name"
                    class="mb-2"
                    dense
                  />
                </v-radio-group>
              </div>
            </template>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="max-width flex-y-center flex-justify-end px-4 py-2">
            <v-btn
              width="80"
              class="mr-3"
              depressed
              @click="formBindDialog.show = false"
            >取消</v-btn>
            <v-btn
              width="80"
              :loading="btnLoading"
              color="primary"
              depressed
              @click="bindForm"
            >确定</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 流程步骤设置弹窗 -->
    <v-dialog
      v-model="stepsDialog.show"
      width="100vw"
      height="100vh"
      persistent
    >
      <v-card
        style="
          height: 100vh;
          max-height: 100vh;
          position: relative;
          display: flex;
          flex-direction: column;
        "
      >
        <!-- 标题栏 -->
        <v-card-title class="text-h6 d-flex justify-space-between align-center">
          <span>流程步骤 - {{ stepsDialog.processName }}</span>
          <v-btn
            icon
            style="background-color: #40a9ff; color: white"
            @click="stepsDialog.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <!-- 内容区域 -->
        <v-card-text
          style="padding: 0; flex: 1; position: relative; overflow: hidden"
        >
          <v-progress-circular
            v-if="stepsDialog.loading"
            indeterminate
            color="primary"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 10;
            "
          />
          <div
            v-else
            class="flex-column"
            style="position: relative; height: 100%; width: 100%"
          >
            <!-- 缩放控制 -->
            <div
              class="flex-align-start flex-y-center"
              style="position: absolute; top: 12px; left: 12px; z-index: 4"
            >
              <div class="flex-justify-between">
                <v-btn size="small" @click="changeScaleNum('del')">-</v-btn>
                <span style="margin: 0 6px" class="flex-y-center">{{ stepsDialog.scaleNum }}%</span>
                <v-btn size="small" @click="changeScaleNum('add')">+</v-btn>
              </div>
            </div>
            <!-- 流程步骤内容区域 -->
            <div
              style="
                display: inline-block !important;
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                text-align: center;
                overflow-x: auto;
                background: #fff;
              "
            >
              <div
                style="
                  display: inline-flex;
                  flex-direction: column;
                  align-items: center;
                  transform: scale(1);
                "
                :style="{
                  transform: 'scale(' + stepsDialog.scaleNum / 100 + ')',
                }"
              >
                <!-- 流程步骤渲染 -->
                <condition
                  v-for="(item, index) in stepsDialog.treeInfo"
                  :key="index"
                  :params-obj="item"
                  :params-index="index"
                  @addList="addList"
                  @delList="delList"
                  @refreshSteps="refreshSteps"
                  @showDrawer="showDrawer"
                  @updata="
                    (e) => {
                      item = e;
                    }
                  "
                />
                <template
                  v-if="stepsDialog.treeInfo && stepsDialog.treeInfo.length"
                >
                  <div class="endding">流程结束</div>
                </template>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- 底部操作栏 -->
        <div
          style="
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;
            border-top: 1px solid #e0e0e0;
            padding: 10px 16px;
            background: #fff;
            text-align: right;
            z-index: 1;
          "
        >
          <v-btn
            width="80"
            color="#40a9ff"
            depressed
            @click="stepsDialog.show = false"
          >关闭</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- 发起人选择弹窗 -->
    <v-dialog v-model="roleSelectDialog.show" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h6"> 发起人 </v-card-title>
        <v-divider />
        <v-card-text style="padding: 20px">
          <v-progress-linear
            v-if="roleSelectDialog.loading"
            indeterminate
            color="primary"
          />
          <div v-else style="height: 400px; overflow: auto">
            <v-tabs v-model="roleSelectDialog.activeTab" class="approver-tabs">
              <v-tab>设置发起人</v-tab>
              <v-tab>表单操作权限</v-tab>
            </v-tabs>
            <v-tabs-items
              v-model="roleSelectDialog.activeTab"
              class="approver-tabs-content"
            >
              <v-tab-item eager>
                <div>
                  <v-checkbox
                    :input-value="isAllRolesSelected"
                    :indeterminate="isSomeRolesSelected"
                    label="选择全部"
                    @change="onToggleSelectAllRoles"
                  />
                  <v-checkbox
                    v-for="role in roleSelectDialog.roles"
                    :key="role.id"
                    v-model="roleSelectDialog.selectedRoles"
                    dense
                    :value="role.id"
                    :label="role.role_name || role.name"
                  />
                </div>
              </v-tab-item>
              <v-tab-item eager>
                <div style="padding: 20px 10px">
                  <!-- 表单权限表格 -->
                  <v-data-table
                    disable-sort
                    hide-default-footer
                    :headers="formPermissionHeaders"
                    :items="formPermissionData"
                    :page="1"
                    :items-per-page="formPermissionData.length"
                    :loading="formPermissionLoading"
                    dense
                    size="small"
                    class="elevation-1 compact-table"
                  >
                    <!-- 表头模板 -->
                    <template v-slot:header.isEdit>
                      <div class="text-center">
                        <v-radio-group
                          v-model="getAllEdit"
                          dense
                          row
                          @change="allOnchangeEdit"
                        >
                          <v-radio dense :value="true" label="可编辑" />
                        </v-radio-group>
                      </div>
                    </template>
                    <template v-slot:header.readOnly>
                      <div class="text-center">
                        <v-radio-group
                          v-model="getAllRead"
                          row
                          dense
                          @change="allOnchangeRead"
                        >
                          <v-radio :value="true" label="只读" />
                        </v-radio-group>
                      </div>
                    </template>
                    <template v-slot:header.isHide>
                      <div class="text-center">
                        <v-radio-group
                          v-model="getAllHide"
                          row
                          dense
                          @change="allOnchangeHide"
                        >
                          <v-radio :value="true" label="隐藏" />
                        </v-radio-group>
                      </div>
                    </template>

                    <!-- 单元格模板 -->
                    <template v-slot:item.isEdit="{ item }">
                      <div class="text-center">
                        <v-radio-group
                          v-model="item.isEdit"
                          row
                          dense
                          @change="onchangeEdit(item)"
                        >
                          <v-radio :value="true" />
                        </v-radio-group>
                      </div>
                    </template>
                    <template v-slot:item.readOnly="{ item }">
                      <div class="text-center">
                        <v-radio-group
                          v-model="item.readOnly"
                          row
                          dense
                          @change="onchangeRead(item)"
                        >
                          <v-radio :value="true" />
                        </v-radio-group>
                      </div>
                    </template>
                    <template v-slot:item.isHide="{ item }">
                      <div class="text-center">
                        <v-radio-group
                          v-model="item.isHide"
                          row
                          dense
                          @change="onchangeHide(item)"
                        >
                          <v-radio :value="true" />
                        </v-radio-group>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <v-card-actions style="padding: 16px">
          <v-spacer />
          <v-btn width="80" depressed @click="roleSelectDialog.show = false">取消</v-btn>
          <v-btn width="80" color="primary" depressed @click="onRoleSelect">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 审批人设置 - 右侧抽屉版本 -->
    <v-navigation-drawer
      v-model="approverDialog.show"
      app
      right
      temporary
      width="800"
      class="approver-drawer"
      :z-index="1000"
      :permanent="approverDialog.show"
      @click.stop.prevent
      @click:outside.stop.prevent
    >
      <div
        class="drawer-content d-flex flex-column"
        style="height: 100vh"
        @click.stop.prevent
        @mousedown.stop.prevent
      >
        <div
          class="drawer-header d-flex justify-space-between align-center pa-4"
          style="border-bottom: 1px solid #e0e0e0"
        >
          <span class="text-h6">审批人</span>
          <v-btn icon @click="approverDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="drawer-body flex-1 pa-4" style="overflow-y: auto">
          <v-tabs v-model="approverDialog.activeTab" class="approver-tabs">
            <v-tab>设置审批人</v-tab>
            <v-tab>表单操作权限</v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="approverDialog.activeTab"
            class="approver-tabs-content"
          >
            <v-tab-item eager>
              <div style="padding: 20px">
                <div style="margin-top: 16px">
                  <v-radio-group
                    v-model="approverDialog.approverType"
                    row
                    dense
                    class="approver-type-group"
                    @change="onApproverTypeChange"
                  >
                    <v-radio :value="1" label="指定成员" />
                    <v-radio :value="5" label="发起人自选" />
                    <v-radio :value="2" label="发起人自己" />
                    <v-radio :value="3" label="项目角色" />
                    <v-radio :value="4" label="上级" />
                  </v-radio-group>
                </div>

                <!-- 指定成员时显示成员选择 -->
                <div
                  v-if="approverDialog.approverType === 1"
                  style="margin-top: 20px"
                >
                  <div
                    style="margin-bottom: 10px; font-weight: 500; color: #333"
                  >
                    已选择的成员：
                  </div>
                  <v-textarea
                    v-model="approverDialog.selectedUserNames"
                    readonly
                    rows="3"
                    placeholder="请选择成员"
                    outlined
                    background-color="#f5f5f5"
                  />
                  <v-btn
                    color="primary"
                    outlined
                    small
                    @click="onShowUserSelectDialog"
                  >
                    选择成员
                  </v-btn>
                </div>

                <!-- 项目角色时显示角色选择 -->
                <div
                  v-if="approverDialog.approverType === 3"
                  style="margin-top: 20px"
                >
                  <div
                    style="margin-bottom: 10px; font-weight: 500; color: #333"
                  >
                    选择项目角色：
                  </div>
                  <v-select
                    v-model="approverDialog.selectedRole"
                    :items="approverDialog.roleList"
                    item-text="role_name"
                    item-value="id"
                    placeholder="请选择项目角色"
                    outlined
                    dense
                    :loading="approverDialog.loading"
                    :disabled="approverDialog.loading"
                  />
                </div>

                <!-- 审批方式选择 -->
                <div style="margin-top: 24px">
                  <div
                    style="margin-bottom: 12px; font-weight: 500; color: #333"
                  >
                    多人审批时采用的审批方式：
                  </div>
                  <v-radio-group
                    v-model="approverDialog.approverMode"
                    class="approver-mode-group"
                    style="font-size: 13px !important"
                  >
                    <v-radio
                      :value="1"
                      label="依次审批"
                      style="font-size: 13px !important"
                    />
                    <v-radio
                      :value="2"
                      label="会签（须所有审批人同意）"
                      style="font-size: 13px !important"
                    />
                    <v-radio
                      :value="3"
                      label="或签（一名审批人同意或拒绝即可）"
                      style="font-size: 13px !important"
                    />
                  </v-radio-group>
                </div>

                <v-divider />
              </div>
            </v-tab-item>

            <v-tab-item eager>
              <div style="padding: 20px">
                <!-- 表单权限表格 -->
                <v-data-table
                  disable-sort
                  hide-default-footer
                  :headers="formPermissionHeaders"
                  :items="formPermissionData"
                  :page="1"
                  :items-per-page="formPermissionData.length"
                  :loading="formPermissionLoading"
                  dense
                  size="small"
                  class="elevation-1 compact-table"
                >
                  <!-- 表头模板 -->
                  <template v-slot:header.isEdit>
                    <div class="text-center">
                      <v-radio-group
                        v-model="getAllEdit"
                        dense
                        row
                        @change="allOnchangeEdit"
                      >
                        <v-radio dense :value="true" label="可编辑" />
                      </v-radio-group>
                    </div>
                  </template>
                  <template v-slot:header.readOnly>
                    <div class="text-center">
                      <v-radio-group
                        v-model="getAllRead"
                        row
                        dense
                        @change="allOnchangeRead"
                      >
                        <v-radio :value="true" label="只读" />
                      </v-radio-group>
                    </div>
                  </template>
                  <template v-slot:header.isHide>
                    <div class="text-center">
                      <v-radio-group
                        v-model="getAllHide"
                        row
                        dense
                        @change="allOnchangeHide"
                      >
                        <v-radio :value="true" label="隐藏" />
                      </v-radio-group>
                    </div>
                  </template>

                  <!-- 单元格模板 -->
                  <template v-slot:item.isEdit="{ item }">
                    <div class="text-center">
                      <v-radio-group
                        v-model="item.isEdit"
                        row
                        dense
                        @change="onchangeEdit(item)"
                      >
                        <v-radio :value="true" />
                      </v-radio-group>
                    </div>
                  </template>
                  <template v-slot:item.readOnly="{ item }">
                    <div class="text-center">
                      <v-radio-group
                        v-model="item.readOnly"
                        row
                        dense
                        @change="onchangeRead(item)"
                      >
                        <v-radio :value="true" />
                      </v-radio-group>
                    </div>
                  </template>
                  <template v-slot:item.isHide="{ item }">
                    <div class="text-center">
                      <v-radio-group
                        v-model="item.isHide"
                        row
                        dense
                        @change="onchangeHide(item)"
                      >
                        <v-radio :value="true" />
                      </v-radio-group>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>

        <div class="drawer-footer pa-4" style="border-top: 1px solid #e0e0e0">
          <div class="d-flex justify-end">
            <v-btn
              class="mr-2"
              width="80"
              depressed
              @click="approverDialog.show = false"
            >取消</v-btn>
            <v-btn
              width="80"
              color="primary"
              depressed
              :loading="btnLoading"
              @click="onApproverSave"
            >确定</v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- 条件设置 - 右侧抽屉版本 -->
    <v-navigation-drawer
      v-model="conditionDialog.show"
      app
      right
      temporary
      width="800"
      class="approver-drawer"
      :z-index="1010"
      :permanent="conditionDialog.show"
    >
      <div
        class="drawer-content d-flex flex-column"
        style="height: 100vh"
        @click.stop.prevent
        @mousedown.stop.prevent
      >
        <div
          class="drawer-header d-flex justify-space-between align-center pa-4"
          style="border-bottom: 1px solid #e0e0e0"
        >
          <span class="text-h6">条件</span>
          <v-btn icon @click="conditionDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="drawer-body flex-1 pa-4" style="overflow-y: auto">
          <div v-if="false" class="flex-y-center">
            <span style="margin-right: 20px">设置条件优先级</span>
            <input
              v-model="conditionDialog.priority"
              placeholder="设置条件优先级"
              type="text"
              class="default-input py-1 subtitle-1"
              style="width: 180px !important"
            >
          </div>
          <div v-for="(item, index) in conditionDialog.conditions" :key="index">
            <div style="margin: 22px 20px 0 0; font-weight: bolder">
              {{ item.field_label }}
            </div>
            <template v-if="item.type === 'checkbox'">
              <div
                class="flex-y-center"
                style="
                  flex-grow: 1;
                  display: inline-flex !important;
                  flex-wrap: wrap;
                "
              >
                <v-checkbox
                  v-for="condition in item.options"
                  :key="condition.value"
                  v-model="item.field_value"
                  dense
                  :value="condition.value"
                  :label="condition.label"
                  style="width: 150px"
                />
              </div>
            </template>
            <template
              v-else-if="item.type === 'radio' || item.type === 'select'"
            >
              <div style="flex-grow: 1" class="condition-radio-flex">
                <v-radio-group v-model="item.field_value" inline>
                  <v-radio
                    v-for="condition in item.options"
                    :key="condition.value"
                    dense
                    :value="condition.value"
                    :label="condition.label"
                    style="width: 150px"
                  />
                </v-radio-group>
              </div>
            </template>
            <template v-else>
              <div
                class="flex-l"
                style="
                  flex-grow: 1;
                  display: inline-flex !important;
                  flex-wrap: wrap;
                  align-items: end;
                "
              >
                <v-select
                  v-model="item.field_condition"
                  label="请选择"
                  :items="[
                    { text: '等于', value: '=' },
                    { text: '大于', value: '＞' },
                    { text: '小于', value: '＜' },
                    { text: '大于等于', value: '＞=' },
                    { text: '小于等于', value: '＜=' },
                  ]"
                  dense
                  outlined
                  style="margin-right: 30px; height: 40px"
                />
                <v-text-field
                  v-model="item.field_value"
                  dense
                  placeholder="请编辑设定值"
                  color="primary"
                  class="default-input py-1 subtitle-1"
                  style="width: 180px !important; height: 40px; cursor: pointer"
                  hide-details
                  :append-icon="'mdi-pencil'"
                  @click:append="changeValuesByDialog(item)"
                />
              </div>
            </template>
          </div>
          <v-btn
            width="80"
            style="margin-top: 20px"
            color="primary"
            depressed
            :loading="btnLoading"
            @click="showAddConditionDialog"
          >添加条件</v-btn>
        </div>
        <div class="drawer-footer pa-4" style="border-top: 1px solid #e0e0e0">
          <div class="d-flex justify-end">
            <v-btn
              class="mr-2"
              width="80"
              depressed
              @click="conditionDialog.show = false"
            >取消</v-btn>
            <v-btn
              width="80"
              color="primary"
              :loading="conditionDialog.loading || btnLoading"
              :disabled="conditionDialog.loading"
              depressed
              @click="onConditionSave"
            >确定</v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- 添加条件弹窗 -->
    <a-modal
      v-if="addConditionDialog.show"
      title="添加条件"
      width="700px"
      :body-style="{ paddingTop: 12 + 'px', paddingBottom: 12 + 'px' }"
      :visible="addConditionDialog.show"
      destroy-on-close
      :z-index="2000"
      :mask-closable="false"
      :keyboard="false"
      :footer="null"
      @cancel="addConditionDialog.show = false"
    >
      <div class="flex-y-center" style="flex-wrap: wrap">
        <v-checkbox
          v-for="condition in addConditionDialog.conditions"
          :key="condition.field_id"
          v-model="addConditionDialog.selectedConditions"
          :value="condition.field_id"
          :label="condition.field_label"
          style="width: 160px; flex-shrink: 0"
          @click="changeAddCondition(condition.field_id)"
        />
      </div>
    </a-modal>
    <!-- 抄送人设置抽屉 -->
    <v-navigation-drawer
      v-model="ccDialog.show"
      app
      right
      temporary
      width="800"
      class="cc-drawer"
      :permanent="ccDialog.show"
    >
      <div class="drawer-content d-flex flex-column" style="height: 100vh">
        <div
          class="drawer-header d-flex justify-space-between align-center pa-4"
          style="border-bottom: 1px solid #e0e0e0"
        >
          <span class="text-h6">抄送人</span>
          <v-btn icon @click="ccDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="drawer-body flex-1 pa-4" style="overflow-y: auto">
          <div style="padding: 20px">
            <div style="margin-bottom: 20px">
              <div style="margin-bottom: 10px; font-weight: 500; color: #333">
                已选择的抄送人：
              </div>
              <v-textarea
                v-model="ccDialog.selectedUserNames"
                readonly
                rows="3"
                placeholder="请选择抄送人"
                outlined
                background-color="#f5f5f5"
              />
              <v-btn
                color="primary"
                outlined
                small
                @click="onShowUserSelectDialog"
              >
                选择抄送人
              </v-btn>
            </div>
          </div>
        </div>

        <div class="drawer-footer pa-4" style="border-top: 1px solid #e0e0e0">
          <div class="d-flex justify-end">
            <v-btn
              class="mr-2"
              width="80"
              depressed
              @click="ccDialog.show = false"
            >取消</v-btn>
            <v-btn
              width="80"
              color="primary"
              depressed
              :loading="btnLoading"
              @click="onCcSave"
            >确定</v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- 用户选择弹窗 - 完全参考另一个项目 -->
    <a-modal
      :title="userSelectDialogTitle"
      width="1200px"
      :body-style="{ paddingTop: 12 + 'px', paddingBottom: 12 + 'px' }"
      :visible="showUserSelectDialog"
      :confirm-loading="approverDialog.loading"
      :z-index="10000"
      :get-container="getContainer"
      :mask-closable="false"
      :keyboard="false"
      ok-text="确认"
      cancel-text="取消"
      @ok="onUserSelectConfirm"
      @cancel="onUserSelectCancel"
      @click.stop.prevent
    >
      <a-spin tip="加载中..." :spinning="approverDialog.loading">
        <div
          class="user-select-content"
          style="pointer-events: auto; position: relative; z-index: 1"
          @click.stop.prevent
          @mousedown.stop.prevent
          @mouseup.stop.prevent
          @touchstart.stop.prevent
          @touchend.stop.prevent
        >
          <a-row
            class="flex-1"
            :gutter="24"
            style="background: #ececec; padding: 10px"
          >
            <a-col :span="8" style="padding-left: 0; padding-right: 0">
              <a-card
                :bordered="false"
                style="max-height: 615px; overflow: auto"
              >
                <template v-if="approverDialog.nodeType === 'chart-sponsor'">
                  <a-checkbox v-model="isAllSponsor"> 所有人 </a-checkbox>
                </template>
                <div
                  class="flex-1 pa-6 max-height max-width white"
                  style="margin-left: -8px"
                >
                  <div
                    v-if="approverDialog.departmentTree.length === 0"
                    style="padding: 20px; text-align: center; color: #999"
                  >
                    暂无部门数据
                  </div>
                  <a-tree
                    v-else
                    :tree-data="approverDialog.departmentTree"
                    :show-line="true"
                    :show-icon="false"
                    :default-expand-all="false"
                    :expand-action="false"
                    @select="onDepartmentSelect"
                    @expand="onDepartmentExpand"
                  />
                  <!-- 调试信息 -->
                  <div
                    v-if="approverDialog.departmentTree.length > 0"
                    style="margin-top: 10px; font-size: 12px; color: #666"
                  >
                    部门树数据:
                    {{ approverDialog.departmentTree.length }} 个根部门
                  </div>
                </div>
              </a-card>
            </a-col>
            <a-col :span="16" style="padding: 0 10px">
              <a-card :bordered="false">
                <a-table
                  size="middle"
                  class="white-space-nowrap"
                  bordered
                  :columns="userTableHeaders"
                  row-key="id"
                  :data-source="approverDialog.userList"
                  :row-selection="{
                    selectedRowKeys:
                      currentDrawerType === 'cc'
                        ? ccDialog.selectedUserIds
                        : approverDialog.selectedUserIds,
                    onChange: onUserSelect,
                    onSelectAll: onUserSelectAll,
                  }"
                >
                  <template slot="gender" slot-scope="text">
                    {{ text === 1 ? '男' : '女' }}
                  </template>
                </a-table>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </a-modal>
    <v-snackbar
      v-model="topSnack.show"
      :color="topSnack.color"
      timeout="3000"
      top
      centered
      multi-line
      class="z-top-snackbar"
    >
      {{ topSnack.text }}
    </v-snackbar>
  </v-card>
</template>

<script>
import Condition from '@/components/condition/index.vue';
import {
  Modal,
  Spin,
  Tree,
  Table,
  Card,
  Row,
  Col,
  Checkbox,
} from 'ant-design-vue';

export default {
  name: 'ProgressTypes',
  components: {
    Condition,
    'a-modal': Modal,
    'a-spin': Spin,
    'a-tree': Tree,
    'a-table': Table,
    'a-card': Card,
    'a-row': Row,
    'a-col': Col,
    'a-checkbox': Checkbox,
  },
  data() {
    return {
      changeValueDialog: {
        show: false,
        value: '',
        selectItem: {},
      },
      search: {
        pageSize: 10,
        pageNo: 1,
        data: { name: '' },
      },
      headers: [
        // { text: '选择', value: 'select', width: 70 },
        { text: '序号', value: 'sortOrder', width: 80 },
        { text: '类型名称', value: 'name' },
        { text: '操作', value: 'active', width: 220 },
      ],
      list: [],
      total: 0,
      selectedItem: [],
      selectedItem1: [],
      selectedTypeId: '',
      selectedTypeName: '',
      itemsPerPage: 10,
      currentPage: 1,
      process: {
        headers: [
          { text: '序号', value: 'index', width: 80 },
          { text: '流程名称', value: 'processName' },
          { text: '关联表单', value: 'formName' },
          { text: '流程步骤', value: 'steps' },
          { text: '操作', value: 'active', width: 220 },
        ],
        list: [],
        search: {
          name: '',
        },
      },
      dialog: {
        show: false,
        data: {},
      },
      processDialog: {
        show: false,
        name: '',
        id: '',
        sortOrder: '',
      },
      btnLoading: false,
      formBindDialog: {
        show: false,
        processId: '',
        processName: '',
        selectedFormId: '',
        forms: [],
      },
      stepsDialog: {
        show: false,
        processId: '',
        processName: '',
        loading: false,
        scaleNum: 100,
        clientHeight: 800,
        treeInfo: [],
      },
      roleSelectDialog: {
        show: false,
        nodeId: '',
        nodeType: '',
        roles: [],
        selectedRoles: [],
        loading: false,
        activeTab: 0,
      },
      approverDialog: {
        show: false,
        nodeId: '',
        nodeType: '',
        stepId: '', // 步骤ID
        examineId: '', // 审批步骤ID
        activeTab: 0,
        approverType: 1, // 1:指定成员 2:发起人自己 3:项目角色 4:上级
        approverMode: 1, // 1:依次审批 2:会签 3:或签
        selectedUsers: [],
        selectedUserNames: '',
        examineUserName: '', // 当前审批人姓名
        departmentTree: [],
        userList: [],
        allUsers: [], // 保存所有用户数据，用于部门过滤
        selectedUserIds: [],
        selectedRole: null, // 选中的项目角色
        roleList: [], // 项目角色列表
        loading: false,
      },
      conditionDialog: {
        show: false,
        priority: 0,
        nodeId: '',
        nodeType: '',
        stepId: '', // 步骤ID
        examineId: '', // 审批步骤ID
        conditions: [],
        selectedConditions: [],
        loading: false,
      },
      showUserSelectDialog: false,
      userSelectDialogTitle: '选择用户', // 用户选择弹窗标题
      currentDrawerType: '', // 当前打开的抽屉类型：'approver' 或 'cc'
      isAllSponsor: false, // 是否选择所有人（发起人专用）
      lastClickTime: 0, // 记录上次点击时间，防止重复点击
      formPermissions: [],
      topSnack: { show: false, text: '', color: 'error' },
      userTableHeaders: [
        { title: '用户账号', dataIndex: 'username', key: 'username' },
        { title: '姓名', dataIndex: 'name', key: 'name' },
        { title: '手机', dataIndex: 'phone', key: 'phone' },
        { title: '邮箱', dataIndex: 'email', key: 'email' },
      ],
      // 表单权限相关数据
      formPermissionHeaders: [
        { text: '表单字段', value: 'field_label', align: 'center' },
        { text: '可编辑', value: 'isEdit', align: 'center', sortable: false },
        { text: '只读', value: 'readOnly', align: 'center', sortable: false },
        { text: '隐藏', value: 'isHide', align: 'center', sortable: false },
      ],
      formPermissionData: [],
      formPermissionLoading: false,
      allEdit: false,
      allRead: false,
      allHide: false,
      currentProcessFormId: '', // 当前流程的表单ID
      // 抄送人抽屉数据
      ccDialog: {
        show: false,
        nodeId: '',
        nodeType: '',
        stepId: '', // 步骤ID
        examineId: '', // 审批步骤ID
        selectedUsers: [],
        selectedUserNames: '',
        selectedUserIds: [],
        departmentTree: [],
        userList: [],
        loading: false,
      },
      addConditionDialog: {
        show: false,
        conditions: [],
        selectedConditions: [],
      },
    };
  },
  computed: {
    getAllEdit() {
      return this.formPermissionData.every((item) => item.isEdit);
    },
    getAllRead() {
      return this.formPermissionData.every((item) => item.readOnly);
    },
    getAllHide() {
      return this.formPermissionData.every((item) => item.isHide);
    },
    validForms() {
      return (this.formBindDialog.forms || []).filter(
        (form) => form && form.id && form.name
      );
    },
    // 分页后的数据
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.process.list.slice(start, end);
    },
    // 总条数
    totalItems() {
      return this.process.list.length;
    },
    // 总页数
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    // 当前页起始条数
    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    // 当前页结束条数
    endItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    },
    isAllRolesSelected() {
      const roles = this.roleSelectDialog.roles || [];
      const selected = this.roleSelectDialog.selectedRoles || [];
      return roles.length > 0 && selected.length === roles.length;
    },
    isSomeRolesSelected() {
      const roles = this.roleSelectDialog.roles || [];
      const selected = this.roleSelectDialog.selectedRoles || [];
      return selected.length > 0 && selected.length < roles.length;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    showTopTip(message, color = 'error') {
      this.topSnack.text = message;
      this.topSnack.color = color;
      this.topSnack.show = true;
    },
    changeValuesByDialog(item) {
      this.changeValueDialog.selectItem = item;
      this.changeValueDialog.value = item.field_value;
      this.changeValueDialog.show = true;
    },
    submitChangeValue() {
      this.$set(
        this.changeValueDialog.selectItem,
        'field_value',
        this.changeValueDialog.value
      );
      this.$forceUpdate();
      this.changeValueDialog.show = false;
    },
    getList() {
      const params = {
        ...this.search.data,
        pageNo: this.search.pageNo,
        pageSize: this.search.pageSize,
      };
      // 点击搜索时，清空右侧流程列表与当前选中类型
      this.selectedTypeId = '';
      this.selectedItem = [];
      this.process.list = [];
      this.btnLoading = true;
      this.$http
        .get(this.$api.processCategoryList, { data: params })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.btnLoading = false;
            const records = res.result.records || [];
            this.list = records;
            this.total = Number(res.result.total || records.length);
          }
        });
    },
    resetSearch() {
      this.search.pageNo = 1;
      this.search.data.name = '';
      // 点击重置时，清空右侧流程列表与当前选中类型
      this.selectedTypeId = '';
      this.selectedItem = [];
      this.process.list = [];
      this.getList();
    },
    resetProcessSearch() {
      this.process.search.name = '';
      this.getProcessList();
    },
    getRowClass(item) {
      return this.selectedItem.id === item.id ? 'selected-row' : '';
    },
    getRowClass1(item) {
      return this.selectedItem1.id === item.id ? 'selected-row' : '';
    },
    onTypeSelectedR(item) {
      this.selectedItem1 = [item];
    },
    onTypeSelected(item) {
      this.selectedItem = [item];
      this.selectedTypeId = item.id;
      this.selectedTypeName = item.name;
      this.getProcessList();
    },
    getProcessList() {
      this.currentPage = 1;
      this.process.list = [];
      console.log('调用getProcessList，selectedTypeId:', this.selectedTypeId);
      if (!this.selectedTypeId) return;
      const params = {
        process_categories_id: this.selectedTypeId,
        processCategoriesId: this.selectedTypeId,
        name: this.process.search.name,
      };
      this.btnLoading = true;
      this.$http
        .get(this.$api.processListByCategoryId, { data: params })
        .then((res) => {
          console.log('getProcessList API响应:', res);
          if (res.code === 0 || res.code === 200) {
            this.btnLoading = false;
            this.process.list = res.result || [];
          }
        });
    },
    showAddProcess() {
      this.processDialog.id = '';
      this.processDialog.name = '';
      this.processDialog.sortOrder = '';
      this.processDialog.show = true;
    },
    onEditProcess(item) {
      this.processDialog.id = item.id;
      this.processDialog.name = item.processName;
      this.processDialog.sortOrder = item.sortOrder || '';
      this.processDialog.show = true;
    },
    onToggleProcess(item) {
      const status = item.publishStatus === 1 ? 0 : 1;
      const payload = { id: item.id, status };
      this.$http
        .post(this.$api.processSetStatus, {
          type: 'application/x-www-form-urlencoded',
          data: payload,
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) this.getProcessList();
        });
    },
    onDeleteProcess(item) {
      this.$confirm({ text: '确认删除该流程吗？' }).then((vm) => {
        const payload = { id: item.id };
        this.$http
          .delete(this.$api.processDelete, { data: payload })
          .then((res) => {
            if (res.code === 0 || res.code === 200) {
              vm.show = false;
              this.$message.success('删除成功');
              this.getProcessList();
            }
          });
      });
    },
    onBindForm(item) {
      this.formBindDialog.processId = item.id;
      this.formBindDialog.processName = item.processName;
      this.formBindDialog.selectedFormId =
        item.processFormId || item.process_form_id || item.formId || '';
      this.formBindDialog.show = true;
      this.getFormsList();
    },
    onSetSteps(item) {
      this.stepsDialog.show = true;
      this.stepsDialog.processId = item.id;
      this.stepsDialog.processName = item.processName;
      this.stepsDialog.loading = true;
      // 保存表单ID
      this.currentProcessFormId = item.processFormId || '';
      console.log('保存表单ID:', this.currentProcessFormId);
      this.getProcessSteps(item.id);
    },
    submitProcess() {
      // 必填项校验
      const sortValid =
        this.processDialog.sortOrder !== undefined &&
        this.processDialog.sortOrder !== null &&
        this.processDialog.sortOrder !== '' &&
        !isNaN(this.processDialog.sortOrder);
      if (
        !sortValid ||
        !Number.isInteger(Number(this.processDialog.sortOrder))
      ) {
        this.$message.error('请填写有效的序号（整数）');
        return;
      }
      if (Number(this.processDialog.sortOrder) > 10000) {
        this.$message.error('序号不能超过10000');
        return;
      }
      if (!this.processDialog.name)
        return this.$message.warning('请输入流程名称');
      // 编辑
      if (this.processDialog.id) {
        const payload = {
          id: this.processDialog.id,
          processName: this.processDialog.name,
          sortOrder: this.processDialog.sortOrder,
        };
        this.$http
          .put(this.$api.processEdit, {
            type: 'application/json',
            data: payload,
          })
          .then((res) => {
            if (res.code === 0 || res.code === 200) {
              this.$message.success('保存成功');
              this.processDialog.show = false;
              this.getProcessList();
            }
          });
        return;
      }
      // 新增
      if (!this.selectedTypeId)
        return this.$message.warning('请先选择一个流程类型');
      const addPayload = {
        processName: this.processDialog.name,
        processCategoriesId: this.selectedTypeId,
        sortOrder: this.processDialog.sortOrder,
      };
      this.$http
        .post(this.$api.processAdd, {
          type: 'application/json',
          data: addPayload,
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success('新增成功');
            this.processDialog.show = false;
            this.getProcessList();
          }
        });
    },
    showAdd() {
      this.dialog.data = { sortOrder: '' };
      this.dialog.show = true;
    },
    onEdit(item) {
      this.dialog.data = {
        id: item.id,
        name: item.name,
        sortOrder: item.sortOrder || '',
      };
      this.dialog.show = true;
    },
    submitSave() {
      const payload = { ...this.dialog.data };
      // 必填项校验
      const sortValid =
        payload.sortOrder !== undefined &&
        payload.sortOrder !== null &&
        payload.sortOrder !== '' &&
        !isNaN(payload.sortOrder);
      if (!sortValid || !Number.isInteger(Number(payload.sortOrder))) {
        this.$message.error('请填写有效的序号（整数）');
        return;
      }
      if (Number(payload.sortOrder) > 10000) {
        this.$message.error('序号不能超过10000');
        return;
      }
      if (!payload.name || !payload.name.toString().trim()) {
        this.$message.error('请填写类型名称');
        return;
      }
      const api = payload.id
        ? this.$api.processCategoryEdit
        : this.$api.processCategoryAdd;
      const method = payload.id ? 'put' : 'post';
      this.$http[method](api, {
        type: 'application/json',
        data: payload,
      }).then((res) => {
        if (res.code === 0 || res.code === 200) {
          this.$message.success('保存成功');
          this.dialog.show = false;
          this.getList();
        }
      });
    },
    onToggle(item) {
      const status = item.status === '1' ? 0 : 1;
      const payload = { id: item.id, status };
      this.$http
        .post(this.$api.processCategorySetStatus, {
          type: 'application/x-www-form-urlencoded',
          data: payload,
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success(status === 1 ? '已禁用' : '已启用');
            this.getList();
          }
        });
    },
    onDelete(item) {
      this.$confirm({ text: '确认删除该类型吗？' }).then((vm) => {
        const payload = { id: item.id };
        this.$http
          .delete(this.$api.processCategoryDelete, { data: payload })
          .then((res) => {
            if (res.code === 0 || res.code === 200) {
              vm.show = false;
              this.$message.success('删除成功');
              const deletedId = item.id;
              const wasSelected = this.selectedTypeId === deletedId;
              this.getList();
              if (wasSelected) {
                this.selectedTypeId = '';
                this.selectedItem = [];
                this.process.list = [];
              } else if (this.selectedTypeId) {
                this.getProcessList();
              }
            }
          });
      });
    },
    getFormsList() {
      const params = {};
      params.pageSize = 9999;
      this.$http
        .get(this.$api.formsList, { data: params })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            // 从分页结果中获取表单列表
            const result = res.result;
            const formsArray = result && result.records ? result.records : [];
            this.formBindDialog.forms = formsArray.filter(
              (form) => form && form.id && form.name
            );
          }
        })
        .catch((err) => {
          console.error('获取表单列表失败:', err);
          this.formBindDialog.forms = [];
        });
    },
    bindForm() {
      if (!this.formBindDialog.selectedFormId) {
        return this.$message.warning('请选择一个表单');
      }
      const payload = {
        processId: this.formBindDialog.processId,
        formId: this.formBindDialog.selectedFormId,
      };
      this.$http
        .post(this.$api.processBindForm, { data: payload })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.$message.success('表单绑定成功');
            this.formBindDialog.show = false;
            this.getProcessList();
          }
        });
    },
    createForm() {
      this.formBindDialog.show = false;
      this.$router.push('/project/processform');
    },
    changeScaleNum(type) {
      if (type === 'del') {
        if (this.stepsDialog.scaleNum > 5) {
          this.stepsDialog.scaleNum = this.stepsDialog.scaleNum - 5;
        } else {
          this.$message.warning('不能再小啦！！！');
        }
      } else {
        this.stepsDialog.scaleNum = this.stepsDialog.scaleNum + 5;
      }
    },
    getProcessSteps(processId) {
      this.roleSelectDialog.selectedRoles = [];
      console.log('调用getProcessSteps，processId:', processId);
      this.$http
        .post(this.$api.processGetSteps, { data: { process_id: processId } })
        .then((res) => {
          this.stepsDialog.loading = false;
          console.log('getProcessSteps API响应:', res);
          if (res.code === 200 || res.code === '200') {
            // 保存表单ID
            if (res.result.form_id) {
              this.currentProcessFormId = res.result.form_id;
              console.log('保存表单ID:', this.currentProcessFormId);
            }

            // 处理流程步骤数据
            console.log('流程步骤数据:', res.result);
            console.log('tree_info数据:', res.result.tree_info);
            console.log(
              'tree_info原始数据:',
              JSON.stringify(res.result.tree_info)
            );

            // 将tree_info转换为数组格式，以匹配参考项目的实现
            if (res.result.tree_info) {
              this.stepsDialog.treeInfo = [res.result.tree_info];
              this.roleSelectDialog.selectedRoles = res.result.roles;
              console.log('设置后的treeInfo:', this.stepsDialog.treeInfo);
              console.log(
                '设置后的treeInfo JSON:',
                JSON.stringify(this.stepsDialog.treeInfo)
              );
            } else {
              this.stepsDialog.treeInfo = [];
            }

            // 根据返回的数据结构处理步骤信息
            this.renderProcessSteps(res.result.tree_info);
          } else {
            this.$message.error(res.message || '获取流程步骤失败');
          }
        })
        .catch((err) => {
          this.stepsDialog.loading = false;
          console.error('获取流程步骤失败:', err);
          this.$message.error('获取流程步骤失败');
        });
    },
    renderProcessSteps(treeInfo) {
      console.log('渲染流程步骤:', treeInfo);

      if (!treeInfo) {
        console.warn('流程步骤数据为空');
        return;
      }

      // 照搬参考项目：将tree_info推入数组
      const processTree = [];
      processTree.push(treeInfo);

      // 照搬参考项目的z函数处理逻辑
      const z = (arr) => {
        arr.forEach((item, index) => {
          if (item.children && item.children.length) {
            if (item.children[0].className === 'chart-condition') {
              // 照搬参考项目第68行：item.children=[{'children':item.children}]
              item.children = [{ children: item.children }];
              console.log('照搬参考项目处理条件分支:', item.children);
              z(item.children[0].children);
            } else {
              if (item.children.length === 1) {
                z(item.children);
              }
            }
          }
        });
      };

      if (processTree.length) {
        z(processTree);
      }

      // 设置处理后的数据
      this.stepsDialog.treeInfo = processTree;

      // 触发Vue的响应式更新
      this.$forceUpdate();
    },

    processTreeData(node) {
      // 完全照搬参考项目的处理逻辑
      if (!node) return;

      console.log('处理节点:', node);

      // 确保每个节点都有必要的属性
      if (!node.className) {
        if (node.name === '发起人' || node.name === '') {
          node.className = 'chart-sponsor';
        } else if (node.name === '审批' || node.name === '审批人') {
          node.className = 'chart-examine';
        } else if (node.name === '抄送' || node.name === '抄送人') {
          node.className = 'chart-cc';
        } else if (node.name === '条件' || node.name === '条件分支') {
          node.className = 'chart-condition';
        }
      }

      // 确保有id属性
      if (!node.id) {
        node.id =
          'node_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      }

      // 完全照搬参考项目的条件分支处理逻辑
      if (node.children && Array.isArray(node.children)) {
        if (
          node.children.length > 0 &&
          node.children[0].className === 'chart-condition'
        ) {
          // 参考项目第68行的处理方式：item.children=[{'children':item.children}]
          node.children = [{ children: node.children }];
          console.log('照搬参考项目处理条件分支:', node.children);

          // 递归处理新创建的条件分支容器
          this.processTreeData(node.children[0]);
        } else {
          // 递归处理子节点
          node.children.forEach((child) => {
            this.processTreeData(child);
          });
        }
      }

      return node;
    },
    addList(obj) {
      console.log('=== 父组件addList方法被调用 ===');
      console.log('父组件接收到添加事件:', obj);
      console.log('添加步骤:', obj);
      const { type, id } = obj;
      const _id = id || 'sponsor_-1';
      const laststr = _id.lastIndexOf('_');
      const newStr = _id.substring(laststr + 1, _id.length);

      let apiUrl = '';
      const payload = {
        process_id: this.stepsDialog.processId,
        last_step_id: newStr,
      };

      if (type === 'chart-examine') {
        apiUrl = this.$api.processExamineAdd;
      } else if (type === 'chart-cc') {
        apiUrl = this.$api.processCcAdd;
      } else if (type === 'chart-condition') {
        apiUrl = this.$api.processConditionAdd;
      }

      if (apiUrl) {
        this.$http
          .post(apiUrl, { data: payload })
          .then((res) => {
            if (res.code === 0 || res.code === 200) {
              // 重新获取流程步骤数据
              this.getProcessSteps(this.stepsDialog.processId);
            } else {
              this.$message.error(res.message || '添加步骤失败');
            }
          })
          .catch((err) => {
            console.error('添加步骤失败:', err);
            this.$message.error('添加步骤失败');
          });
      }
    },
    delList(obj) {
      console.log('=== 父组件delList方法被调用 ===');
      console.log('父组件接收到删除事件:', obj);
      console.log('当前stepsDialog.processId:', this.stepsDialog.processId);
      if (!obj) {
        console.error('删除事件对象为空');
        return;
      }
      const { type, id } = obj;
      console.log('接收到的type:', type);
      console.log('接收到的id:', id);

      if (!id) {
        console.error('删除ID为空，无法删除');
        this.$message.error('删除失败：节点ID为空');
        return;
      }

      const _id = id;
      console.log('使用的_id:', _id);
      const laststr = _id.lastIndexOf('_');
      const newStr = _id.substring(laststr + 1, _id.length);
      console.log('提取的newStr:', newStr);

      let apiUrl = '';
      const payload = {
        process_id: this.stepsDialog.processId,
      };

      if (type === 'chart-examine') {
        apiUrl = this.$api.processExamineDel;
        payload.examine_id = newStr;
      } else if (type === 'chart-cc') {
        apiUrl = this.$api.processCcDel;
        payload.examine_id = newStr;
      } else if (type === 'chart-condition') {
        apiUrl = this.$api.processExamineDel;
        payload.examine_id = newStr;
      }

      if (apiUrl) {
        console.log('apiUrl:', apiUrl);
        this.$http
          .post(apiUrl, { data: payload })
          .then((res) => {
            console.log('删除API响应:', res);
            if (res.code === 0 || res.code === 200) {
              this.$message.success('删除步骤成功');
              console.log('开始刷新数据...');
              // 重新获取流程步骤数据
              this.getProcessSteps(this.stepsDialog.processId);
              // 同步刷新右侧流程列表
              this.getProcessList();
              console.log('刷新数据调用完成');
            } else {
              this.$message.error(res.message || '删除步骤失败');
            }
          })
          .catch((err) => {
            console.error('删除步骤失败:', err);
            this.$message.error('删除步骤失败');
          });
      }
    },
    addListC(obj, m) {
      console.log('添加子步骤:', obj, m);
      // 根据参考项目，addListC主要用于在条件分支中添加子步骤
      // 这里可以调用相应的API来添加子步骤
      this.addList(obj);
    },
    delListC(obj, m) {
      console.log('删除子步骤:', obj, m);
      // 根据参考项目，delListC主要用于删除条件分支中的子步骤
      // 这里可以调用相应的API来删除子步骤
      this.delList(obj);
    },
    refreshSteps() {
      console.log('刷新流程步骤数据');
      // 重新获取流程步骤数据
      this.getProcessSteps(this.stepsDialog.processId);
      // 同步刷新右侧流程列表
      this.getProcessList();
    },
    showDrawer(data) {
      console.log('=== 父组件showDrawer方法被调用 ===');
      console.log('显示抽屉:', data);
      console.log('data.type:', data.type);
      console.log('data.id:', data.id);
      console.log('完整data对象:', JSON.stringify(data));
      if (data.type === 'chart-sponsor') {
        // 发起人节点，显示角色选择弹窗
        this.$nextTick(() => {
          this.roleSelectDialog.show = true;
          this.roleSelectDialog.nodeId = data.id || '';
          this.roleSelectDialog.nodeType = data.type;
          this.getRolesList();
          // 加载表单权限数据
          this.getFormPermissionData(data.type);
        });
      } else if (data.type === 'chart-examine') {
        // 审批节点，显示审批人设置弹窗
        this.$nextTick(() => {
          this.approverDialog.show = true;
          this.approverDialog.nodeId = data.id || '';
          this.approverDialog.nodeType = data.type;
          this.approverDialog.activeTab = 0;

          // 打开抽屉时清空上次的选择，确保 auditUsers 为空
          this.approverDialog.selectedUserIds = [];
          this.approverDialog.selectedUsers = [];
          this.approverDialog.selectedUserNames = '';
          this.approverDialog.selectedRole = null;

          // 从节点ID中提取步骤ID (例如: examine_1908 -> 1908)
          const nodeId = data.id || '';
          const idx = nodeId.lastIndexOf('_');
          const stepId = idx > -1 ? nodeId.substring(idx + 1) : nodeId;
          this.approverDialog.stepId = stepId;
          this.approverDialog.examineId = stepId; // 审批节点的步骤ID

          console.log('审批人节点信息:', {
            nodeId: nodeId,
            stepId: stepId,
            examineId: stepId,
          });

          this.currentDrawerType = 'approver'; // 设置当前抽屉类型
          this.getDepartmentTree();
          // 如果是项目角色，获取角色列表
          if (
            data.type === 'chart-examine' &&
            this.approverDialog.approverType === 3
          ) {
            this.getRoleList();
          }
          // 加载表单权限数据
          this.getFormPermissionData(data.type);
        });
      } else if (data.type === 'chart-cc') {
        // 抄送节点，显示抄送人设置抽屉
        console.log('=== 处理抄送人节点 ===');
        console.log('data.id:', data.id);
        console.log('data.type:', data.type);
        console.log('data完整对象:', JSON.stringify(data));
        this.$nextTick(() => {
          this.ccDialog.show = true;
          this.ccDialog.nodeId = data.id || '';
          this.ccDialog.nodeType = data.type;

          // 从节点ID中提取步骤ID (例如: cc_1909 -> 1909)
          const nodeId = data.id || '';
          const idx = nodeId.lastIndexOf('_');
          const stepId = idx > -1 ? nodeId.substring(idx + 1) : nodeId;
          this.ccDialog.stepId = stepId;
          this.ccDialog.examineId = stepId; // 抄送节点的步骤ID
          console.log('抄送人节点信息:', {
            nodeId: nodeId,
            stepId: stepId,
            examineId: stepId,
          });
          console.log('设置后的ccDialog:', {
            nodeId: this.ccDialog.nodeId,
            stepId: this.ccDialog.stepId,
            examineId: this.ccDialog.examineId,
          });

          this.currentDrawerType = 'cc'; // 设置当前抽屉类型
          this.getDepartmentTree();
          // 获取已设置的抄送人数据
          this.getCcData();
        });
      } else {
        // 其他节点类型，可以在这里添加其他处理逻辑
        console.log('其他节点类型:', data.type);
        this.conditionDialog.show = true;
        this.conditionDialog.nodeId = data.id || '';
        this.conditionDialog.nodeType = data.type;
        this.getConditionData();
      }
    },
    async getCcList() {
      await this.$http.post(this.$api.getCcUser, {
        data: {
          step_id: this.ccDialog.stepId,
        },
      });
    },
    async getRolesList() {
      // 获取角色列表，用于发起人角色选择
      try {
        this.roleSelectDialog.loading = true;
        const response = await this.$http.get(this.$api.getRoleList);
        if (response.code === 0 || response.code === 200) {
          this.roleSelectDialog.roles = response.result || [];
          console.log('发起人角色列表:', this.roleSelectDialog.roles);
        } else {
          this.$message.error(response.message || '获取角色列表失败');
          // 使用模拟数据作为备选
          this.roleSelectDialog.roles = [
            { id: '1', name: '管理员' },
            { id: '2', name: '部门经理' },
            { id: '3', name: '普通员工' },
          ];
        }
      } catch (error) {
        console.error('获取角色列表失败:', error);
        this.$message.error('获取角色列表失败');
        // 使用模拟数据作为备选
        this.roleSelectDialog.roles = [
          { id: '1', name: '管理员' },
          { id: '2', name: '部门经理' },
          { id: '3', name: '普通员工' },
        ];
      } finally {
        this.roleSelectDialog.loading = false;
      }
    },
    async getRoleList() {
      // 获取项目角色列表，用于审批人设置
      try {
        this.approverDialog.loading = true;
        const response = await this.$http.get(this.$api.getRoleList);
        if (response.code === 0 || response.code === 200) {
          this.approverDialog.roleList = response.result || [];
        } else {
          this.$message.error(response.message || '获取角色列表失败');
        }
      } catch (error) {
        console.error('获取角色列表失败:', error);
        this.$message.error('获取角色列表失败');
        // 使用模拟数据作为备选
        this.approverDialog.roleList = [
          { id: '1', name: '管理员' },
          { id: '2', name: '部门经理' },
          { id: '3', name: '普通员工' },
          { id: '4', name: '项目经理' },
          { id: '5', name: '技术负责人' },
        ];
      } finally {
        this.approverDialog.loading = false;
      }
    },
    onRoleSelect() {
      console.log('选择角色:', this.roleSelectDialog.selectedRoles);
      if (this.roleSelectDialog.selectedRoles.length === 0) {
        this.$message.error('请至少选择一个角色');
        return;
      }
      // 校验：每个表单字段必须选择一种权限（可编辑/只读/隐藏）
      const hasInvalidPermission = (this.formPermissionData || []).some(
        (field) => !field.isEdit && !field.readOnly && !field.isHide
      );
      if (hasInvalidPermission) {
        this.showTopTip('请为每个表单字段选择权限（可编辑/只读/隐藏）');
        return;
      }
      this.$http.post(this.$api.saveRolePermissionData, {
        data: {
          process_id: this.stepsDialog.processId,
          audit_pemission: this.formPermissionData,
        },
      });

      // roleSave
      this.$http
        .post(this.$api.roleSave, {
          data: {
            process_id: this.stepsDialog.processId,
            roles: this.roleSelectDialog.selectedRoles,
          },
        })
        .then((res) => {
          console.log('examineSave接口返回:', res);
          if (res.code === 0 || res.code === 200) {
            this.roleSelectDialog.show = false;
            this.$message.success(res.message || '发起人角色设置成功');
            this.getProcessSteps(this.stepsDialog.processId);
            this.approverDialog.show = false;
          } else {
            this.$message.error(res.message || '保存失败');
          }
          // 权限接口保存
        })
        .catch((error) => {
          this.$message.error('保存发起人角色设置失败');
        });
    },
    onSelectAllRoles() {
      const roles = this.roleSelectDialog.roles || [];
      this.roleSelectDialog.selectedRoles = roles.map((r) => r.id);
    },
    onToggleSelectAllRoles(val) {
      const roles = this.roleSelectDialog.roles || [];
      if (val) {
        this.roleSelectDialog.selectedRoles = roles.map((r) => r.id);
      } else {
        this.roleSelectDialog.selectedRoles = [];
      }
    },
    getDepartmentTree() {
      // 获取部门树数据 - 同时设置给审批人和抄送人抽屉
      const departmentTree = [
        {
          key: '1',
          title: '公司总部',
          children: [
            {
              key: '1-1',
              title: '技术部',
              children: [
                { key: '1-1-1', title: '前端组' },
                { key: '1-1-2', title: '后端组' },
              ],
            },
            {
              key: '1-2',
              title: '市场部',
              children: [
                { key: '1-2-1', title: '销售组' },
                { key: '1-2-2', title: '推广组' },
              ],
            },
          ],
        },
      ];

      // 同时设置给审批人和抄送人抽屉
      this.approverDialog.departmentTree = departmentTree;
      this.ccDialog.departmentTree = departmentTree;
    },
    onDepartmentSelect(selectedKeys, info) {
      console.log('选择部门:', selectedKeys, info);
      // 根据选择的部门过滤用户列表
      this.filterUsersByDepartment(selectedKeys[0]);
    },
    // 根据部门ID过滤用户列表
    filterUsersByDepartment(departmentId) {
      console.log('过滤部门用户，部门ID:', departmentId);

      if (!departmentId) {
        // 如果没有选择部门，显示所有用户
        this.approverDialog.userList = [...this.approverDialog.allUsers];
        console.log('显示所有用户，数量:', this.approverDialog.userList.length);
        return;
      }

      // 根据部门ID过滤用户
      const filteredUsers = this.approverDialog.allUsers.filter((user) => {
        // 精确匹配用户的departmentId
        return user.departmentId === departmentId;
      });

      this.approverDialog.userList = filteredUsers;
      console.log(`部门 ${departmentId} 的用户数量:`, filteredUsers.length);
      console.log('过滤后的用户列表:', filteredUsers);
    },
    getUserList(departmentId) {
      // 模拟获取用户列表 - 参考另一个项目
      this.approverDialog.userList = [
        {
          id: '1',
          username: 'zhangsan',
          name: '张三',
          phone: '13800138001',
          email: 'zhangsan@example.com',
          gender: 1,
        },
        {
          id: '2',
          username: 'lisi',
          name: '李四',
          phone: '13800138002',
          email: 'lisi@example.com',
          gender: 1,
        },
        {
          id: '3',
          username: 'wangwu',
          name: '王五',
          phone: '13800138003',
          email: 'wangwu@example.com',
          gender: 1,
        },
        {
          id: '4',
          username: 'zhaoliu',
          name: '赵六',
          phone: '13800138004',
          email: 'zhaoliu@example.com',
          gender: 0,
        },
        {
          id: '5',
          username: 'liuqi',
          name: '刘七',
          phone: '13800138005',
          email: 'liuqi@example.com',
          gender: 0,
        },
        {
          id: '6',
          username: 'chenba',
          name: '陈八',
          phone: '13800138006',
          email: 'chenba@example.com',
          gender: 1,
        },
      ];
    },
    onUserSelect(selectedRowKeys, selectedRows) {
      console.log('onUserSelect被调用:', selectedRowKeys, selectedRows);
      console.log('当前抽屉类型:', this.currentDrawerType);

      // 根据当前抽屉类型，保存到相应的抽屉中
      if (this.currentDrawerType === 'cc') {
        // 抄送人抽屉
        this.ccDialog.selectedUserIds = selectedRowKeys;
        this.ccDialog.selectedUsers = selectedRows;
        this.ccDialog.selectedUserNames = selectedRows
          .map((user) => user.name)
          .join('、');
        console.log('保存到抄送人抽屉:', {
          selectedUserIds: this.ccDialog.selectedUserIds,
          selectedUsers: this.ccDialog.selectedUsers,
          selectedUserNames: this.ccDialog.selectedUserNames,
        });
      } else {
        // 审批人抽屉（默认）
        this.approverDialog.selectedUserIds = selectedRowKeys;
        this.approverDialog.selectedUsers = selectedRows;
        this.approverDialog.selectedUserNames = selectedRows
          .map((user) => user.name)
          .join('、');
        console.log('保存到审批人抽屉:', {
          selectedUserIds: this.approverDialog.selectedUserIds,
          selectedUsers: this.approverDialog.selectedUsers,
          selectedUserNames: this.approverDialog.selectedUserNames,
        });
      }
    },
    onUserSelectAll(selected, selectedRows, changeRows) {
      console.log('全选用户:', selected, selectedRows, changeRows);
      console.log('当前抽屉类型:', this.currentDrawerType);

      // 根据当前抽屉类型，保存到相应的抽屉中
      if (this.currentDrawerType === 'cc') {
        // 抄送人抽屉
        if (selected) {
          this.ccDialog.selectedUserIds = selectedRows.map((user) => user.id);
          this.ccDialog.selectedUsers = selectedRows;
          this.ccDialog.selectedUserNames = selectedRows
            .map((user) => user.name)
            .join('、');
        } else {
          this.ccDialog.selectedUserIds = [];
          this.ccDialog.selectedUsers = [];
          this.ccDialog.selectedUserNames = '';
        }
        console.log('全选保存到抄送人抽屉:', {
          selectedUserIds: this.ccDialog.selectedUserIds,
          selectedUsers: this.ccDialog.selectedUsers,
          selectedUserNames: this.ccDialog.selectedUserNames,
        });
      } else {
        // 审批人抽屉（默认）
        if (selected) {
          this.approverDialog.selectedUserIds = selectedRows.map(
            (user) => user.id
          );
          this.approverDialog.selectedUsers = selectedRows;
          this.approverDialog.selectedUserNames = selectedRows
            .map((user) => user.name)
            .join('、');
        } else {
          this.approverDialog.selectedUserIds = [];
          this.approverDialog.selectedUsers = [];
          this.approverDialog.selectedUserNames = '';
        }
        console.log('全选保存到审批人抽屉:', {
          selectedUserIds: this.approverDialog.selectedUserIds,
          selectedUsers: this.approverDialog.selectedUsers,
          selectedUserNames: this.approverDialog.selectedUserNames,
        });
      }
    },
    onApproverSave() {
      // 完全参考另一个项目的参数组织
      try {
        const nodeId = this.approverDialog.nodeId || '';
        const idx = nodeId.lastIndexOf('_');
        const examineId = idx > -1 ? nodeId.substring(idx + 1) : nodeId;

        // 根据审批人类型获取相应的用户数据
        let auditUsers = [];
        console.info(this.approverDialog.approverType);
        switch (this.approverDialog.approverType) {
          case 1: // 指定成员
            auditUsers = this.approverDialog.selectedUserIds || [];
            break;
          case 2: // 发起人自己
            auditUsers = []; // 发起人自己不需要指定用户ID
            break;
          case 3: // 项目角色
            auditUsers = this.approverDialog.selectedRole
              ? [this.approverDialog.selectedRole]
              : [];
            break;
          case 4: // 上级
            auditUsers = []; // 上级不需要指定用户ID
            break;
          default:
            auditUsers = [];
        }

        // 表单权限占位（参考项目从字段权限收集），此处保持结构一致
        const payload = {
          process_id: this.stepsDialog.processId,
          examine_id: examineId,
          audit_user_type: this.approverDialog.approverType,
          examine_user_type: this.approverDialog.approverType,
          audit_users: auditUsers,
          examine_users: auditUsers,
          audit_type: this.approverDialog.approverMode,
          examine_type: this.approverDialog.approverMode,
          audit_pemission: this.formPermissionData,
          empty_type: 1,
          charge_replace: '',
        };

        // 校验：每个表单字段必须选择一种权限（可编辑/只读/隐藏）
        const hasInvalidPermission = (this.formPermissionData || []).some(
          (field) => !field.isEdit && !field.readOnly && !field.isHide
        );
        if (hasInvalidPermission) {
          this.showTopTip('请为每个表单字段选择权限（可编辑/只读/隐藏）');
          return;
        }

        console.log('保存审批人设置 - 详细调试信息:', {
          nodeId: nodeId,
          examineId: examineId,
          processId: this.stepsDialog.processId,
          approverType: this.approverDialog.approverType,
          selectedUserIds: this.approverDialog.selectedUserIds,
          selectedRole: this.approverDialog.selectedRole,
          auditUsers: auditUsers,
          payload: payload,
        });

        console.log('发送到examineSave接口的数据:', payload);

        if (
          payload.examine_user_type === 1 ||
          payload.examine_user_type === '1'
        ) {
          // 指定成员
          if (payload.audit_users.length === 0) {
            this.showTopTip('请选择审批人');
            return;
          }
        }

        if (
          payload.examine_user_type === 3 ||
          payload.examine_user_type === '3'
        ) {
          // 项目角色：必须选择至少一个角色
          if (!Array.isArray(auditUsers) || auditUsers.length === 0) {
            this.showTopTip('请选择项目角色');
            return;
          }
        }

        this.$http
          .post(this.$api.examineSave, { data: payload })
          .then((res) => {
            console.log('examineSave接口返回:', res);
            if (res.code === 0 || res.code === 200) {
              this.$message.success(res.message || '审批人设置成功');
              this.approverDialog.show = false;
              // 保存成功后，刷新流程
              if (this.stepsDialog && this.stepsDialog.processId) {
                this.getProcessSteps(this.stepsDialog.processId);
              }
            } else {
              this.$message.error(res.message || '保存失败');
            }
          })
          .catch((error) => {
            console.error('examineSave接口调用失败:', error);
            this.$message.error('保存审批人设置失败');
          });
      } catch (e) {
        console.error('保存审批人设置异常', e);
        this.$message.error('保存审批人设置异常');
      }
    },
    onUserSelectConfirm() {
      console.log('确认选择用户:', this.approverDialog.selectedUsers);
      console.log('当前抽屉类型:', this.currentDrawerType);

      this.showUserSelectDialog = false;

      // 根据当前抽屉类型，保持相应的抽屉打开状态
      if (this.currentDrawerType === 'cc') {
        // 如果是从抄送人抽屉打开的，保持抄送人抽屉打开
        this.ccDialog.show = true;
        console.log('保持抄送人抽屉打开');
      } else if (this.currentDrawerType === 'approver') {
        // 如果是从审批人抽屉打开的，保持审批人抽屉打开
        this.approverDialog.show = true;
        console.log('保持审批人抽屉打开');
      }

      console.log(
        '关闭用户选择弹窗后，审批人抽屉状态:',
        this.approverDialog.show
      );
      console.log('关闭用户选择弹窗后，抄送人抽屉状态:', this.ccDialog.show);
    },
    onUserSelectCancel() {
      // 取消选择，根据当前抽屉类型清空相应的用户数据
      // if (this.currentDrawerType === 'cc') {
      //   // 清空抄送人抽屉的用户数据
      //   this.ccDialog.selectedUsers = []
      //   this.ccDialog.selectedUserIds = []
      //   this.ccDialog.selectedUserNames = ''
      //   console.log('清空抄送人抽屉的用户数据')
      // } else {
      //   // 清空审批人抽屉的用户数据（默认）
      //   this.approverDialog.selectedUsers = []
      //   this.approverDialog.selectedUserIds = []
      //   this.approverDialog.selectedUserNames = ''
      //   console.log('清空审批人抽屉的用户数据')
      // }

      this.isAllSponsor = false;
      this.showUserSelectDialog = false;

      // 根据当前抽屉类型，保持相应的抽屉打开状态
      if (this.currentDrawerType === 'cc') {
        // 如果是从抄送人抽屉打开的，保持抄送人抽屉打开
        this.ccDialog.show = true;
        console.log('取消选择后保持抄送人抽屉打开');
      } else if (this.currentDrawerType === 'approver') {
        // 如果是从审批人抽屉打开的，保持审批人抽屉打开
        this.approverDialog.show = true;
        console.log('取消选择后保持审批人抽屉打开');
      }
    },
    onShowUserSelectDialog() {
      const currentTime = Date.now();
      console.log('=== onShowUserSelectDialog 被调用 ===');
      console.log('点击选择成员按钮');
      console.log('当前showUserSelectDialog值:', this.showUserSelectDialog);
      console.log('当前loading状态:', this.approverDialog.loading);
      console.log(
        '当前时间:',
        currentTime,
        '上次点击时间:',
        this.lastClickTime
      );

      // 防止重复调用 - 使用时间戳防重复点击
      if (currentTime - this.lastClickTime < 1000) {
        console.log('点击过于频繁，忽略重复调用');
        return;
      }

      // 防止重复调用
      if (this.showUserSelectDialog) {
        console.log('用户选择弹窗已经打开，忽略重复调用');
        return;
      }

      this.lastClickTime = currentTime;

      // 根据当前打开的抽屉类型设置弹窗标题
      if (this.approverDialog.show) {
        this.userSelectDialogTitle = '选择审批人';
      } else if (this.ccDialog.show) {
        this.userSelectDialogTitle = '选择抄送人';
      } else {
        this.userSelectDialogTitle = '选择用户';
      }

      this.showUserSelectDialog = true;
      console.log('设置后showUserSelectDialog值:', this.showUserSelectDialog);
      console.log('弹窗标题:', this.userSelectDialogTitle);
      console.log('准备调用getDepartmentTree2');
      // 通过接口获取部门树和用户数据
      this.getDepartmentTree2();
    },
    getContainer() {
      return document.body;
    },
    // 通过接口获取部门树和用户数据
    async getDepartmentTree2() {
      console.log('=== getDepartmentTree2 被调用 ===');
      console.log('当前loading状态:', this.approverDialog.loading);

      // 防止重复调用
      if (this.approverDialog.loading) {
        console.log('getDepartmentTree2接口正在调用中，忽略重复请求');
        return;
      }

      try {
        this.approverDialog.loading = true;
        console.log('开始调用getDepartmentTree2接口获取数据');

        // 尝试使用项目封装的$http.post
        let response;
        try {
          response = await this.$http.post(this.$api.getDepartmentTree2, {
            data: {},
          });
        } catch (error) {
          console.log('使用$http.post失败，尝试使用原生axios发送JSON数据');
          // 如果项目封装的$http.post失败，使用原生axios发送JSON数据
          const axios = require('axios');
          response = await axios.post(
            this.$api.getDepartmentTree2,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );
          response = response.data;
        }
        console.log('getDepartmentTree2接口返回数据:', response);

        if (response.code === 0 || response.code === 200) {
          // 根据API返回的数据结构设置部门树数据
          const departments = response.result.departments || [];
          this.approverDialog.departmentTree =
            this.convertDepartmentTree(departments);

          // 设置所有用户数据（从根部门和子部门的members中获取）
          this.approverDialog.allUsers = this.extractAllUsers(departments);
          this.approverDialog.userList = [...this.approverDialog.allUsers]; // 初始显示所有用户

          console.log('部门树数据:', this.approverDialog.departmentTree);
          console.log('用户列表数据:', this.approverDialog.userList);
        } else {
          this.$message.error(response.message || '获取部门树和用户数据失败');
          // 使用模拟数据作为备选
          this.getDepartmentTree();
          this.getUserList();
        }
      } catch (error) {
        console.error('获取部门树和用户数据失败:', error);
        this.$message.error('获取部门树和用户数据失败');
        // 使用模拟数据作为备选
        this.getDepartmentTree();
        this.getUserList();
      } finally {
        this.approverDialog.loading = false;
      }
    },
    // 从部门数据中提取所有用户
    extractAllUsers(departments) {
      if (!departments || !Array.isArray(departments)) {
        return [];
      }

      let allUsers = [];

      // 递归提取所有部门的用户
      const extractUsersFromDepartment = (dept) => {
        if (dept.members && Array.isArray(dept.members)) {
          // 转换用户数据格式以匹配表格显示
          const users = dept.members
            .map((member) => ({
              id: member.id,
              username: member.username,
              name: member.realname || member.username,
              phone: member.phone,
              email: member.email,
              gender: member.user_category === '1' ? 1 : 0, // 根据user_category判断性别
              org_code: member.org_code,
              departmentId: dept.id, // 添加部门ID，用于过滤
              departmentName: dept.title || dept.depart_name || dept.name, // 添加部门名称
              status: member.status,
            }))
            .filter((member) => {
              // 检查allUsers中是否已存在该用户
              return !allUsers.some((user) => user.id === member.id);
            });
          allUsers = allUsers.concat(users);
        }

        // 递归处理子部门
        if (dept.children && dept.children.length > 0) {
          dept.children.forEach((child) => extractUsersFromDepartment(child));
        }
      };

      departments.forEach((dept) => extractUsersFromDepartment(dept));

      console.log('提取到的用户数据:', allUsers);
      return allUsers;
    },
    // 将API返回的部门数据转换为Ant Design Tree组件需要的格式
    convertDepartmentTree(departments) {
      console.log('convertDepartmentTree 接收到的数据:', departments);
      if (!departments || !Array.isArray(departments)) {
        console.log('convertDepartmentTree: 数据为空或不是数组');
        return [];
      }

      const result = departments.map((dept) => {
        const treeNode = {
          title: dept.title || dept.depart_name || dept.name,
          key: dept.id,
          value: dept.id,
          children: [],
        };

        console.log(`转换部门: ${treeNode.title} (${treeNode.key})`);

        // 递归处理子部门，确保多级结构正确转换
        if (dept.children && dept.children.length > 0) {
          treeNode.children = this.convertDepartmentTree(dept.children);
          console.log(
            `部门 ${treeNode.title} 有 ${treeNode.children.length} 个子部门`
          );
        }

        return treeNode;
      });

      console.log('convertDepartmentTree 转换结果:', result);
      return result;
    },
    // 处理部门树展开/折叠事件
    onDepartmentExpand(expandedKeys, info) {
      console.log('展开/折叠部门:', expandedKeys, info);
    },
    // 监听审批人类型变化
    onApproverTypeChange() {
      if (this.approverDialog.approverType === 3) {
        // 选择项目角色时，获取角色列表
        this.getRoleList();
      }
    },
    // 表单权限相关方法
    onchangeEdit(item) {
      item.readOnly = false;
      item.isHide = false;
    },
    onchangeRead(item) {
      item.isEdit = false;
      item.isHide = false;
    },
    onchangeHide(item) {
      item.isEdit = false;
      item.readOnly = false;
    },
    allOnchangeEdit() {
      this.allRead = false;
      this.allHide = false;
      this.formPermissionData.forEach((item) => {
        this.$set(item, 'isEdit', true);
        this.$set(item, 'readOnly', false);
        this.$set(item, 'isHide', false);
      });
    },
    allOnchangeRead() {
      this.allEdit = false;
      this.allHide = false;
      this.formPermissionData.forEach((item) => {
        this.$set(item, 'isEdit', false);
        this.$set(item, 'readOnly', true);
        this.$set(item, 'isHide', false);
      });
    },
    allOnchangeHide() {
      this.allEdit = false;
      this.allRead = false;
      this.formPermissionData.forEach((item) => {
        this.$set(item, 'isEdit', false);
        this.$set(item, 'readOnly', false);
        this.$set(item, 'isHide', true);
      });
    },
    // 发起人 获取表单字段权限数据
    getRolePermissionData() {
      this.$http
        .post(this.$api.getRolePermissionData, {
          data: { process_id: this.stepsDialog.processId },
        })
        .then((res) => {
          if (res.result.pems && res.result.pems.length > 0) {
            res.result.pems.forEach((fieldPemission) => {
              this.formPermissionData.forEach((field) => {
                if (field.field_id === fieldPemission.fieldId) {
                  field.isEdit = fieldPemission.edit;
                  field.isHide = fieldPemission.hide;
                  field.fieldPemission = fieldPemission.fieldPemission;
                  field.readOnly = fieldPemission.readOnly;
                }
              });
            });
          }
        });
    },
    // 审批人 获取表单字段权限数据
    async getFormPermissionData(type) {
      try {
        this.formPermissionLoading = true;
        this.btnLoading = true;

        // 获取当前流程的表单ID
        // 从流程数据中获取表单ID，或者使用流程ID作为备选
        const formId =
          this.stepsDialog.formId ||
          this.currentProcessFormId ||
          this.stepsDialog.processId;

        if (!formId) {
          console.warn('没有找到表单ID，无法获取表单字段');
          this.formPermissionData = [];
          return;
        }

        console.log('使用表单ID获取字段:', formId);

        // 调用后台接口获取表单字段
        const response = await this.$http.post(this.$api.formField, {
          data: {
            form_id: formId,
          },
        });

        if (response.code === 0 || response.code === 200) {
          // 处理返回的字段数据，添加权限控制属性
          this.formPermissionData = (response.result.fields || []).map(
            (field) => ({
              field_id: field.field_id,
              field_label: field.field_label,
              field_name: field.field_name,
              field_type: field.field_type,
              required: field.required,
              options: field.options || [],
              isEdit: false,
              readOnly: true,
              isHide: false,
            })
          );
          console.log('获取表单字段成功:', this.formPermissionData);
          if (type === 'chart-sponsor') {
            await this.getRolePermissionData();
          } else {
            await this.getExamineData();
          }

          console.info(this.formPermissionData);
        } else {
          this.$message.error(response.message || '获取表单字段失败');
          this.formPermissionData = [];
        }
      } catch (error) {
        console.error('获取表单权限数据失败:', error);
        this.$message.error('获取表单权限数据失败');
        this.formPermissionData = [];
      } finally {
        this.formPermissionLoading = false;
      }
    },
    async getExamineData() {
      // 调用后台接口获取表单字段
      const examineResponse = await this.$http.post(this.$api.examineGet, {
        data: {
          process_id: this.stepsDialog.processId,
          examine_id: this.approverDialog.examineId,
        },
      });
      this.btnLoading = false;
      console.info(examineResponse);

      // 保存审批人姓名到已选择的成员文本框中
      if (examineResponse.result && examineResponse.result.examine_user_name) {
        this.approverDialog.examineUserName =
          examineResponse.result.examine_user_name;
        this.approverDialog.selectedUserNames =
          examineResponse.result.examine_user_name;
        this.approverDialog.selectedUserIds =
          examineResponse.result.examine_user_ids;
        console.log('当前审批人姓名:', this.approverDialog.examineUserName);
      } else {
        this.approverDialog.examineUserName = '';
        this.approverDialog.selectedUserNames = '';
      }
      // 审批方式 1：依次审批 2：会签 3：或签
      this.approverDialog.approverMode =
        examineResponse.result.examine_type === 0
          ? 1
          : examineResponse.result.examine_type;
      // 审批人类型1：指定成员 2：发起人自己 3：项目角色 4：上级
      this.approverDialog.approverType =
        examineResponse.result.examine_user_type === 0
          ? 1
          : examineResponse.result.examine_user_type;
      if (examineResponse.result.examine_user_type === 3) {
        await this.getRoleList();
        // 项目角色的时候
        const roleId = examineResponse.result.examine_users.replace(
          /\[(.*?)\]/g,
          '$1'
        );
        console.info('roleId', roleId);
        this.approverDialog.selectedRole = roleId;
      }
      examineResponse.result.pems.forEach((fieldPemission) => {
        this.formPermissionData.forEach((field) => {
          if (field.field_id === fieldPemission.fieldId) {
            field.isEdit = fieldPemission.edit;
            field.isHide = fieldPemission.hide;
            field.fieldPemission = fieldPemission.fieldPemission;
            field.readOnly = fieldPemission.readOnly;
          }
        });
      });
    },
    showAddConditionDialog() {
      this.addConditionDialog.show = true;
    },
    async changeAddCondition(id) {
      const index = this.conditionDialog.conditions.findIndex((item) => {
        return item.field_id === id;
      });
      if (index === -1) {
        const response = await this.$http.post(this.$api.getStepCondition, {
          data: {
            step_id: parseInt(
              this.conditionDialog.nodeId.split('condition_')[1]
            ),
            field_id: id,
          },
        });
        if (response.code === 0 || response.code === 200) {
          this.conditionDialog.conditions.push(response.result.field);
          this.conditionDialog.conditions = this.conditionDialog.conditions.map(
            (item) => {
              return {
                ...item,
                selectedConditions: [],
              };
            }
          );
        } else {
          this.$message.error(response.message || '获取表单字段失败');
        }
      } else {
        const response = await this.$http.post(this.$api.processConditionDel, {
          data: {
            condition_id: parseInt(
              this.conditionDialog.nodeId.split('condition_')[1]
            ),
          },
        });
        if (response.code === 0 || response.code === 200) {
          this.conditionDialog.conditions.splice(index, 1);
        } else {
          this.$message.error(response.message || '失败');
        }
      }
      this.addConditionDialog.show = false;
    },
    // 获取条件分支数据
    async getConditionData() {
      try {
        this.conditionDialog.loading = true;
        // 获取当前流程的表单ID
        // 从流程数据中获取表单ID，或者使用流程ID作为备选
        const formId =
          this.stepsDialog.formId ||
          this.currentProcessFormId ||
          this.stepsDialog.processId;

        if (!formId) {
          console.warn('没有找到表单ID，无法获取表单字段');
          this.formPermissionData = [];
          return;
        }
        console.log('使用表单ID获取字段:', formId);
        // 调用后台接口获取表单字段
        this.btnLoading = true;
        this.conditionDialog.conditions = [];
        this.addConditionDialog.selectedConditions = [];
        const response = await this.$http.post(this.$api.formField, {
          data: {
            form_id: formId,
          },
        });
        if (response.code === 0 || response.code === 200) {
          this.btnLoading = false;
          this.addConditionDialog.conditions = response.result.condition_fields;
        } else {
          this.$message.error(response.message || '获取表单字段失败');
        }
        this.btnLoading = true;
        const response2 = await this.$http.post(this.$api.conditionAll, {
          data: {
            step_id: parseInt(
              this.conditionDialog.nodeId.split('condition_')[1]
            ),
          },
        });
        this.btnLoading = false;
        if (response2.code === 0 || response2.code === 200) {
          this.conditionDialog.priority = response2.result.priority;
          this.conditionDialog.conditions = response2.result.fields;
          this.conditionDialog.conditions.forEach((item) => {
            this.addConditionDialog.selectedConditions.push(item.field_id);
            if (item.type === 'checkbox' && item.field_value === '') {
              item.field_value = [];
            }
          });
        } else {
          this.$message.error(response.message || '获取已添加表单字段失败');
        }
      } catch (error) {
        console.error('获取表单权限数据失败:', error);
        this.$message.error('获取表单权限数据失败');
      } finally {
        this.conditionDialog.loading = false;
      }
    },
    async onConditionSave() {
      const params = {
        step_id: parseInt(this.conditionDialog.nodeId.split('condition_')[1]),
        priority: this.conditionDialog.priority,
      };
      const conditions = [];
      this.conditionDialog.conditions.forEach((item) => {
        conditions.push({
          field_condition: item.field_condition,
          field_id: item.field_id,
          field_value: item.field_value,
          field_type: item.field_type,
        });
      });
      params.conditions = conditions;
      this.btnLoading = true;
      const response = await this.$http.post(this.$api.saveConditionsStep, {
        data: params,
      });
      if (response.code === 0 || response.code === 200) {
        this.btnLoading = false;
        this.conditionDialog.show = false;
      } else {
        this.$message.error(response.message || '失败');
      }
    },
    // 获取抄送人数据
    async getCcData() {
      try {
        const stepId = this.ccDialog.stepId || this.ccDialog.examineId;
        const processId = this.stepsDialog.processId;

        console.log('获取抄送人数据 - 参数:', {
          processId: processId,
          stepId: stepId,
        });

        if (!processId || !stepId) {
          console.warn('流程ID或步骤ID为空，无法获取抄送人数据');
          return;
        }

        const response = await this.$http.post(this.$api.processCcGet, {
          data: {
            process_id: processId,
            examine_id: stepId,
          },
        });

        console.log('获取抄送人数据响应:', response);

        if (response.code === 0 || response.code === 200) {
          const result = response.result || response.data;
          if (result) {
            // 解析cc_users字段（JSON字符串格式）
            let ccUserIds = [];
            if (result.cc_users) {
              try {
                // 如果cc_users是字符串，需要解析JSON
                if (typeof result.cc_users === 'string') {
                  const parsed = JSON.parse(result.cc_users);
                  ccUserIds = Array.isArray(parsed) ? parsed : [];
                } else if (Array.isArray(result.cc_users)) {
                  ccUserIds = result.cc_users;
                } else {
                  console.warn('cc_users格式不正确:', result.cc_users);
                  ccUserIds = [];
                }
              } catch (e) {
                console.warn(
                  '解析cc_users失败:',
                  e,
                  '原始数据:',
                  result.cc_users
                );
                ccUserIds = [];
              }
            }

            // 设置已选择的抄送人
            this.ccDialog.selectedUserIds = ccUserIds;
            this.ccDialog.selectedUserNames = result.user_name || '';

            // 如果有用户ID，需要获取用户详细信息
            if (ccUserIds && Array.isArray(ccUserIds) && ccUserIds.length > 0) {
              // 这里可以根据需要获取用户详细信息
              // 暂时使用ID作为用户信息
              this.ccDialog.selectedUsers = ccUserIds.map((id) => ({
                id: id,
                name: `用户${id}`, // 临时名称，实际应该从用户列表获取
              }));
            } else {
              this.ccDialog.selectedUsers = [];
            }

            console.log('设置抄送人数据:', {
              selectedUserIds: this.ccDialog.selectedUserIds,
              selectedUserNames: this.ccDialog.selectedUserNames,
              selectedUsers: this.ccDialog.selectedUsers,
              rawCcUsers: result.cc_users,
            });
          }
        } else {
          console.warn('获取抄送人数据失败:', response.message);
          // 清空数据
          this.ccDialog.selectedUserIds = [];
          this.ccDialog.selectedUsers = [];
          this.ccDialog.selectedUserNames = '';
        }
      } catch (error) {
        console.error('获取抄送人数据异常:', error);
        // 清空数据
        this.ccDialog.selectedUserIds = [];
        this.ccDialog.selectedUsers = [];
        this.ccDialog.selectedUserNames = '';
      }
    },
    // 抄送人保存方法
    onCcSave() {
      try {
        // 获取步骤ID - 从抄送人抽屉的步骤信息中获取
        const stepId = this.ccDialog.stepId || this.ccDialog.examineId;

        console.log('保存抄送人设置 - 详细调试信息:', {
          stepId: stepId,
          processId: this.stepsDialog.processId,
          selectedUserIds: this.ccDialog.selectedUserIds,
          selectedUsers: this.ccDialog.selectedUsers,
          ccDialog: this.ccDialog,
          'ccDialog.stepId': this.ccDialog.stepId,
          'ccDialog.examineId': this.ccDialog.examineId,
          'ccDialog.nodeId': this.ccDialog.nodeId,
        });

        // 数据验证和清理
        const processId = this.stepsDialog.processId;
        if (!processId) {
          this.$message.error('流程ID不能为空');
          return;
        }

        if (!stepId) {
          console.error('步骤ID为空，调试信息:', {
            'ccDialog.stepId': this.ccDialog.stepId,
            'ccDialog.examineId': this.ccDialog.examineId,
            'ccDialog.nodeId': this.ccDialog.nodeId,
          });
          this.$message.error('步骤ID不能为空，请检查节点ID是否正确');
          return;
        }

        // 清理用户ID数组，移除空值和无效值
        const validUserIds = (this.ccDialog.selectedUserIds || []).filter(
          (id) => id && id.toString().trim() !== ''
        );

        if (validUserIds.length === 0) {
          this.$message.warning('请至少选择一个抄送人');
          return;
        }

        const payload = {
          examine_user_type: 0,
          process_id: processId.toString(), // 保持字符串格式
          examine_id: stepId.toString(), // 保持字符串格式
          cc_users: validUserIds.map((id) => id.toString()), // 保持字符串格式
        };

        console.log('发送到processCcSave接口的数据:', payload);

        this.$http
          .post(this.$api.processCcSave, { data: payload })
          .then((res) => {
            console.log('processCcSave接口返回:', res);
            if (res.code === 0 || res.code === 200) {
              this.$message.success(res.message || '抄送人设置成功');
              this.ccDialog.show = false;
              // 保存成功后，刷新流程
              if (this.stepsDialog && this.stepsDialog.processId) {
                this.getProcessSteps(this.stepsDialog.processId);
              }
            } else {
              this.$message.error(res.message || '保存失败');
            }
          })
          .catch((error) => {
            console.error('processCcSave接口调用失败:', error);
            this.$message.error('保存抄送人设置失败');
          });
      } catch (e) {
        console.error('保存抄送人设置异常', e);
        this.$message.error('保存抄送人设置异常');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-radio-group {
  max-height: 400px;
  overflow-y: auto;
}
.type-table
  ::v-deep
  .v-data-table__wrapper
  table
  tbody
  tr.v-data-table__selected {
  background-color: #e3f2fd !important; /* 选中行的背景色 */
}

/* 鼠标悬停时的样式 */
.type-table ::v-deep .v-data-table__wrapper table tbody tr:hover {
  background-color: #f5f5f5 !important;
}

/* 确保选中行在悬停时也保持高亮 */
.type-table
  ::v-deep
  .v-data-table__wrapper
  table
  tbody
  tr.v-data-table__selected:hover {
  background-color: #e3f2fd !important;
}

.form-title {
  width: 90px;
  color: #777;
}

.endding {
  position: relative;
  text-align: center;
  line-height: 50px;
  margin: auto;
  &:before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 10px;
    height: 10px;
    margin: auto;
    border: none;
    margin-bottom: 12px;
    border-radius: 50%;
    background: #dbdcdc;
  }
}

.approver-drawer {
  .approver-tabs {
    border-bottom: 1px solid #e0e0e0;
  }

  .approver-tabs-content {
    min-height: 400px;
    max-height: calc(100vh - 160px);
    overflow: auto;
  }
}

/* 审批人抽屉样式 */
.approver-drawer {
  z-index: 1001 !important;
}

.drawer-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.drawer-header {
  flex-shrink: 0;
  background: white;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  background: white;
}

.drawer-footer {
  flex-shrink: 0;
  background: white;
}

.radio-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
  min-height: 48px !important;
}
.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: row;
}

/* 审批人类型横排、小字号 */
.approver-type-group ::v-deep .v-label {
  font-size: 13px !important;
}

/* 抄送人抽屉样式 */
.cc-drawer {
  z-index: 9999 !important;
}

/* 用户选择弹窗样式 - 确保显示在最顶层 */
.user-select-dialog {
  z-index: 999999 !important;
}

/* 用户选择弹窗样式 - 确保显示在最顶层 */
.user-select-dialog {
  z-index: 10000 !important;
}

.user-select-dialog .v-dialog__content {
  z-index: 10000 !important;
}

/* 强制用户选择弹窗显示在最顶层 */
::v-deep .user-select-dialog {
  z-index: 10000 !important;
}

::v-deep .user-select-dialog .v-dialog__content {
  z-index: 10000 !important;
}

::v-deep .user-select-dialog .v-overlay__content {
  z-index: 10000 !important;
}
.approver-type-group ::v-deep .v-radio {
  margin-right: 12px !important;
}
.approver-type-group ::v-deep .v-input--selection-controls__input {
  margin-right: 8px !important;
}

/* 审批方式单选组样式 */
.approver-mode-group ::v-deep .v-label {
  font-size: 13px !important;
}
.approver-mode-group ::v-deep .v-radio {
  margin-bottom: 8px !important;
}
.approver-mode-group ::v-deep .v-input--selection-controls__input {
  margin-right: 8px !important;
}

/* 让类型列表整行垂直居中，首列选择框生效 */
.type-table ::v-deep .v-data-table__wrapper table tbody tr {
  height: 48px;
}
.type-table ::v-deep .v-data-table__wrapper table tbody tr > td {
  vertical-align: middle;
}

::v-deep(.v-dialog) {
  margin: 0;
  &:not(.v-dialog--fullscreen) {
    max-height: 100%;
  }
}
</style>

<style>
/* 全局样式 - 确保用户选择弹窗显示在最顶层 */
.user-select-dialog {
  z-index: 10000 !important;
}

/* 提示信息置顶，避免被对话框覆盖（Element/消息类库通过 customClass 应用） */
.z-top-message {
  z-index: 50000 !important;
}

/* 顶部 Snackbar 层级提升 */
.z-top-snackbar {
  z-index: 100000 !important;
}

/* 审批人抽屉样式 */
.approver-drawer {
  z-index: 1000 !important;
}

.approver-drawer .v-navigation-drawer__content {
  z-index: 1000 !important;
}

/* 防止事件穿透 */
.drawer-content {
  position: relative;
  z-index: 1001;
  pointer-events: auto;
}

/* 用户选择弹窗内容 */
.user-select-content {
  position: relative;
  z-index: 10001;
  pointer-events: auto;
}

.user-select-dialog .v-dialog__content {
  z-index: 999999 !important;
}

.user-select-dialog .v-overlay__content {
  z-index: 999999 !important;
}

/* 强制覆盖所有可能的z-index */
.v-dialog.user-select-dialog {
  z-index: 999999 !important;
}

.v-dialog.user-select-dialog .v-dialog__content {
  z-index: 999999 !important;
}

.v-dialog.user-select-dialog .v-overlay__content {
  z-index: 999999 !important;
}

/* 强制覆盖Vuetify的默认z-index */
.v-overlay.user-select-dialog {
  z-index: 999999 !important;
}

.v-overlay.user-select-dialog .v-dialog__content {
  z-index: 999999 !important;
}
.selected-row {
  background-color: #00e2ff !important;
}
.v-data-table__selected .text-start {
  color: #2196f3 !important;
}
/* 强制覆盖Ant Design Modal的z-index */
.ant-modal {
  z-index: 999999 !important;
}

.ant-modal-mask {
  z-index: 999999 !important;
}

.ant-modal-wrap {
  z-index: 999999 !important;
}
.v-select__menu {
  z-index: 9999991 !important;
}
/* 紧凑模式样式 */
.compact-table {
  --v-data-table-density: compact;
}
.compact-table >>> th,
.compact-table >>> td {
  padding: 8px 12px !important; /* 调整单元格内边距 */
  height: 36px !important; /* 固定行高 */
}
.no-underline .v-input__slot::before {
  border: none !important;
}

.no-underline .v-text-field__slot::before {
  border: none !important;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}
</style>
<style lang="scss">
.header-grey .v-data-table__wrapper > table > tbody > tr > td {
  height: 42px;
  color: rgba(41, 41, 41, 0.87);
}
.condition-radio-flex {
  .v-input--radio-group__input {
    flex-direction: row;
    align-items: flex-start;
  }
}
</style>
<style>
.compact-table ::v-deep .v-data-table__wrapper table tbody tr {
  height: 32px !important;
}

.compact-table ::v-deep .v-data-table__wrapper table td {
  padding: 2px 4px !important;
}

.compact-table ::v-deep .v-data-table-header th {
  padding: 4px 4px !important;
  height: 36px !important;
}

.compact-table ::v-deep .v-input--radio-group__input {
  font-size: 12px !important;
}

.compact-table ::v-deep .v-radio {
  margin-right: 8px !important;
}
</style>
